import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 0.5,
};

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
}));

export default function UserModal({ userId, onClose }) {
  const [userData, setUserData] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setError(null);

      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("Token not available. Please log in.");
        }

        const userResponse = await axios.get(
          `${API_BASE_URL}User/Find/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setUserData({
          username: userResponse.data.userName,
        });
      } catch (err) {
        // إذا التوكن منتهي
        if (err.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بعد التحديث
            const retryResponse = await axios.get(
              `${API_BASE_URL}User/Find/${userId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setUserData({
              username: retryResponse.data.userName,
            });
          } catch (retryError) {
            alert("Retry failed: " + retryError.message);
          }
        } else {
          // أي خطأ ثاني
          //  console.error(err);
          setError("حدث خطأ أثناء جلب البيانات");
        }
      }
    };

    fetchData();
  }, [userId]);

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <CardHeader
            dir="ltr"
            action={
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            }
            sx={{ textAlign: "center" }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Avatar
              alt={userData?.userName || "N/A"}
              sx={{
                bgcolor: userData?.imagePath ? "transparent" : "primary.main",
                width: 100,
                height: 100,
              }}
            >
              {!userData?.imagePath && <AccountCircleIcon fontSize="large" />}
            </Avatar>
          </Box>

          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            {error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <AccountCircleIcon sx={{ mr: 1, color: "green" }} />
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <strong>اسم المشرف:</strong>{" "}
                    <strong>{userData?.username || "N/A"}</strong>
                  </Typography>
                </Box>
              </>
            )}
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}
